/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonChangeOfobject,
    JsonChangeOfobjectFromJSON,
    JsonChangeOfobjectFromJSONTyped,
    JsonChangeOfobjectToJSON,
} from './JsonChangeOfobject';

/**
 * 
 * @export
 * @interface JsonPlace
 */
export interface JsonPlace {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonPlace
     */
    allowedActions?: Array<JsonPlaceAllowedActionsEnum>;
    /**
     * 
     * @type {Array<JsonChangeOfobject>}
     * @memberof JsonPlace
     */
    changes?: Array<JsonChangeOfobject>;
    /**
     * 
     * @type {string}
     * @memberof JsonPlace
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonPlace
     */
    createdBy?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonPlace
     */
    eventId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonPlace
     */
    foodCapacity?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonPlace
     */
    foodServices?: Array<JsonPlaceFoodServicesEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof JsonPlace
     */
    isAcm?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JsonPlace
     */
    isFood?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JsonPlace
     */
    isMeet?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JsonPlace
     */
    isPark?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JsonPlace
     */
    isWork?: boolean;
    /**
     * 
     * @type {number}
     * @memberof JsonPlace
     */
    parkCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonPlace
     */
    placeId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonPlace
     */
    status?: JsonPlaceStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonPlace
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonPlace
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonPlace
     */
    updatedBy?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonPlaceAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonPlaceFoodServicesEnum {
    Br = 'BR',
    Lu = 'LU',
    Di = 'DI',
    Sn = 'SN'
}/**
* @export
* @enum {string}
*/
export enum JsonPlaceStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE'
}

export function JsonPlaceFromJSON(json: any): JsonPlace {
    return JsonPlaceFromJSONTyped(json, false);
}

export function JsonPlaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonPlace {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'changes': !exists(json, 'changes') ? undefined : ((json['changes'] as Array<any>).map(JsonChangeOfobjectFromJSON)),
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'eventId': !exists(json, 'eventId') ? undefined : json['eventId'],
        'foodCapacity': !exists(json, 'foodCapacity') ? undefined : json['foodCapacity'],
        'foodServices': !exists(json, 'foodServices') ? undefined : json['foodServices'],
        'isAcm': !exists(json, 'isAcm') ? undefined : json['isAcm'],
        'isFood': !exists(json, 'isFood') ? undefined : json['isFood'],
        'isMeet': !exists(json, 'isMeet') ? undefined : json['isMeet'],
        'isPark': !exists(json, 'isPark') ? undefined : json['isPark'],
        'isWork': !exists(json, 'isWork') ? undefined : json['isWork'],
        'parkCapacity': !exists(json, 'parkCapacity') ? undefined : json['parkCapacity'],
        'placeId': !exists(json, 'placeId') ? undefined : json['placeId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
    };
}

export function JsonPlaceToJSON(value?: JsonPlace | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'changes': value.changes === undefined ? undefined : ((value.changes as Array<any>).map(JsonChangeOfobjectToJSON)),
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'eventId': value.eventId,
        'foodCapacity': value.foodCapacity,
        'foodServices': value.foodServices,
        'isAcm': value.isAcm,
        'isFood': value.isFood,
        'isMeet': value.isMeet,
        'isPark': value.isPark,
        'isWork': value.isWork,
        'parkCapacity': value.parkCapacity,
        'placeId': value.placeId,
        'status': value.status,
        'title': value.title,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
    };
}

